/**
 * Created by daniesy on 09/11/2016.
 */

import Question from './question';
import Conclusion from './conclusion';

var d3 = require('d3');

export default class PopupData {
    constructor(data) {
        this.questions = [];
        this._conclusion = {};
        this.extractData(data);
    }

    extractData(data) {
        data.forEach(element => {
            if (element.question) {
                if (element.question != '-') {
                    let question = new Question(element.title, element.question, element.answer)
                    this.questions.push(question);
                    question.addData({cta: + element.cta, date: element.date, spx: +element.spx});
                } else {
                    this._conclusion = new Conclusion(element.conclusion);
                }
            } else {
                let question = this.questions[element.index];
                question.addData({cta: +element.cta, date: element.date, spx: +element.spx});
            }
        });
    }

    questionAtIndex(index) {
        return this.questions[index];
    }

    animationStepAtIndex(index) {
        return this.questions[index].data[0].date;
    }

    lastQuestion(index) {
        return this.questions.length <= index;
    }

    getAnswers() {
      return this.questions.map(question => {
        return {
          title: question.title,
          correct: question.correct,
          formattedDate: question.data[0].date,
          date: d3.timeParse("%d-%m-%Y")(question.data[0].date)
        }
      });
    }

    get conclusion() {
        return this._conclusion;
    }
}



// WEBPACK FOOTER //
// ./src/js/popupData.js